import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../pages/Dashboard';

import BookingWrapper from '../pages/booking/BookingWrapper';
import BookingInfo from '../pages/booking/info/BookingInfo';
import SkiWrapper from '../pages/booking/ski/SkiWrapper';
import SkiRental from '../pages/booking/ski/rental/SkiRental';
import SkiRentalOverview from '../pages/booking/ski/rental/SkiRentalOverview';
import SkiRentalAvailableProducts from '../pages/booking/ski/rental/SkiRentalAvailableProducts';
import SkiRentalPickupPlaces from '../pages/booking/ski/rental/SkiRentalPickupPlaces';
import SkiPass from '../pages/booking/ski/pass/SkiPass';
import SkiPassOverview from '../pages/booking/ski/pass/SkiPassOverview';
import SkiPassAvailableProducts from '../pages/booking/ski/pass/SkiPassAvailableProducts';
import SkiSchool from '../pages/booking/ski/school/SkiSchool';
import SkiSchoolOverview from '../pages/booking/ski/school/SkiSchoolOverview';
import SkiSchoolAvailableProducts from '../pages/booking/ski/school/SkiSchoolAvailableProducts';
import Stats from '../pages/stats/Stats';
import SalesStats from '../pages/stats/SalesStats';
import GiftVoucher from '../pages/gift-vouchers/GiftVoucher';
import GiftVoucherBookingList from '../pages/gift-vouchers/GiftVoucherBookingList';
import GiftVoucherEmailList from '../pages/gift-vouchers/GiftVoucherEmailList';
import TriggerWrapper from '../pages/triggers/TriggerWrapper';
import TriggerTemplates from '../pages/triggers/TriggerTemplates';
import TriggerRules from '../pages/triggers/TriggerRules';
import TriggerLists from '../pages/triggers/TriggerLists';
import TriggerListsOverdueReminders from '../pages/triggers/TriggerListsOverdueReminders';
import TriggerListsLastReminder from '../pages/triggers/TriggerListsLastReminder';
import Affiliates from '../pages/affiliates/affiliates';

import PageNotFound from '../pages/error-pages/PageNotFound';
import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/statistics',
      name: 'Stats',
      component: Stats,
      children: [
        {
          path: 'sales-statistics',
          name: 'SalesStats',
          component: SalesStats,
          meta: {
            title: 'Sales Statistics',
          },
        },
      ],
    },
    {
      path: '/gift-voucher',
      name: 'GiftVoucher',
      component: GiftVoucher,
      redirect: { name: 'GiftVoucherBookingList' },
      children: [
        {
          path: 'booking-list',
          name: 'GiftVoucherBookingList',
          component: GiftVoucherBookingList,
          meta: {
            title: 'Gift Voucher - Booking List',
          },
        },
        {
          path: 'email-list',
          name: 'GiftVoucherEmailList',
          component: GiftVoucherEmailList,
          meta: {
            title: 'Gift Voucher - Email List',
          },
        },
      ],
    },
    {
      path: '/triggers',
      name: 'Triggers',
      component: TriggerWrapper,
      redirect: { name: 'TriggerTemplates' },
      children: [
        {
          path: 'templates',
          name: 'TriggerTemplates',
          component: TriggerTemplates,
          meta: {
            title: 'Triggers - Templates',
          },
        },
        {
          path: 'rules',
          name: 'TriggerRules',
          component: TriggerRules,
          meta: {
            title: 'Triggers - Rules',
          },
        },
        {
          path: 'lists',
          name: 'TriggerLists',
          component: TriggerLists,
          children: [
            {
              path: 'overdue',
              name: 'TriggerListsOverdueReminders',
              component: TriggerListsOverdueReminders,
              meta: {
                title: 'Reminders - Overdue',
              },
            },
            {
              path: 'last-trigger',
              name: 'TriggerListsLastReminder',
              component: TriggerListsLastReminder,
              meta: {
                title: 'Triggers - Last Reminder',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/booking/:bookingId',
      name: 'BookingWrapper',
      component: BookingWrapper,
      props: true,
      redirect: { name: 'BookingInfo' },
      children: [
        {
          path: 'info',
          name: 'BookingInfo',
          component: BookingInfo,
          meta: {
            title: 'Booking info',
          },
        },
        {
          path: 'ski',
          name: 'SkiWrapper',
          component: SkiWrapper,
          redirect: { name: 'SkiRental' },
          children: [
            {
              path: 'rental',
              name: 'SkiRental',
              component: SkiRental,
              props: true,
              redirect: { name: 'SkiRentalOverview' },
              meta: {
                title: 'Ski rental',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiRentalOverview',
                  component: SkiRentalOverview,
                  meta: {
                    title: 'Ski rental: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiRentalAvailableProducts',
                  component: SkiRentalAvailableProducts,
                  meta: {
                    title: 'Ski rental: Available products',
                  },
                },
                {
                  path: 'pickup-places',
                  name: 'SkiRentalPickupPlaces',
                  component: SkiRentalPickupPlaces,
                  props: {
                    skiRental: true,
                  },
                  meta: {
                    title: 'Ski rental: Pickup places',
                  },
                },
              ],
            },
            {
              path: 'pass',
              name: 'SkiPass',
              component: SkiPass,
              props: true,
              redirect: { name: 'SkiPassOverview' },
              meta: {
                title: 'Ski pass',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiPassOverview',
                  component: SkiPassOverview,
                  meta: {
                    title: 'Ski pass: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiPassAvailableProducts',
                  component: SkiPassAvailableProducts,
                  meta: {
                    title: 'Ski pass: Available products',
                  },
                },
                {
                  path: 'pickup-places',
                  name: 'SkiPassPickupPlaces',
                  component: SkiRentalPickupPlaces,
                  meta: {
                    title: 'Ski pass: Pickup places',
                  },
                },
              ],
            },
            {
              path: 'school',
              name: 'SkiSchool',
              component: SkiSchool,
              props: true,
              redirect: { name: 'SkiSchoolOverview' },
              meta: {
                title: 'Ski school',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiSchoolOverview',
                  component: SkiSchoolOverview,
                  meta: {
                    title: 'Ski school: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiSchoolAvailableProducts',
                  component: SkiSchoolAvailableProducts,
                  meta: {
                    title: 'Ski school: Available products',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/affiliates',
      name: 'Affiliates',
      component: Affiliates,
      meta: {
        title: 'Affiliates',
      },
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'Twenty Booking';
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js